import { Pagination } from './Pagination'

export class UserCMS {
  public success: boolean
  public message: string
  public data?: AdminCMS[]
  public pagination?: Pagination

  constructor(
    success: boolean,
    message: string,
    data?: AdminCMS[],
    pagination?: Pagination
  ) {
    this.success = success
    this.message = message
    this.data = data
    this.pagination = pagination
  }
}

export class AdminCMS {
  public name: string
  public email: string
  public phone: string
  public roleName: string
  public roleId: number
  public needSalesCode?: boolean
  public password: string
  public lastLogin: number
  public id: number

  constructor(
    name: string,
    email: string,
    phone: string,
    roleName: string,
    roleId: number,
    needSalesCode: boolean,
    password: string,
    lastLogin: number,
    id: number
  ) {
    this.name = name
    this.email = email
    this.phone = phone
    this.roleName = roleName
    this.roleId = roleId
    this.needSalesCode = needSalesCode
    this.password = password
    this.lastLogin = lastLogin
    this.id = id
  }
}
